import { DataService } from "base/services";
import { useAccountStore } from "base/stores";

export const handleCommunityRedirection = async (isNewTab = false) => {
  const searchParams = new URLSearchParams(window.location.search);
  const communityURL = searchParams.get("url");
  const { _id } = useAccountStore.getState();
  const { pathname, search = "" } = window.location;

  const [ssoRequest] = DataService.get(
    `/signin/2/${_id}/sso/community?state=${communityURL}`
  );
  const response = await ssoRequest().catch((err) => {
    window.location.replace("/login");
    localStorage.setItem("redirectURL", pathname + search);
    console.info(err, "error while trying to redirect community page");
  });
  if (isNewTab) {
    window.open(response.RedirectURL, "_blank");
  } else {
    window.location.href = response.RedirectURL;
  }
};
